import { useEffect, useState } from 'react';

import { useGrowthBook } from '@growthbook/growthbook-react';

import { INITIAL_STATE } from './constants';

const useFeatureFlags = () => {
    const growthbook = useGrowthBook();
    const [features, setFeatures] = useState(INITIAL_STATE);
    const rawFeatures = growthbook?.getFeatures();

    useEffect(() => {
        if (rawFeatures && growthbook?.ready) {
            const mappedFeatures: Record<string, boolean> = {};

            for (const key of Object.keys(rawFeatures)) {
                mappedFeatures[key] = growthbook.evalFeature(key).on;
            }

            setFeatures(features => ({ ...features, ...mappedFeatures }));
        }
    }, [rawFeatures, growthbook]);

    return {
        ACCOUNT_DRAWER_LAYOUT: features.account_drawer_layout,
        CUSTOMER_INVOICING: features.customer_invoicing,
        CUSTOMERS: features.customers,
        DDM: features.ddm_connection,
        EAVISION: features.eavision,
        FAA_REPORTS: features.faa_reports,
        FIELD_VIEW: features.field_view,
        FLIGHT_GROUPS: features.flight_groups,
        FLIGHT_LOG_LIST: features.flight_log_list,
        INCENTIVE_PROGRAM_UI: features.incentive_program_ui,
        INTERCOM_CHAT: features.intercom_chat,
        JOHN_DEERE: features.john_deere,
        MANAGE_CONNECTIONS: features.manage_connections,
        OPERATOR_MAP_TILE: features.operator_map_tile,
        PDF_EXTRACTION: features.pdf_extraction,
        PRODUCT_USAGE_REPORT_DELETE: features.product_usage_report_delete,
        PRODUCT_USAGE_REPORT_EDIT: features.product_usage_report_edit,
        QUICKBOOKS: features.quickbooks,
        STATE_REPORTING: features.state_reporting,
        V2_RESKIN: features.v2_reskin,
        V2_RESKIN_CUTOFF: features.v2_reskin_cutoff
    };
};

export default useFeatureFlags;
